export const billingExplorerTotalGridViewInitialSelectedCsvColumns = new Set([
  "region",
  "account",
  "resource_id",
  "resource_name",
]);

export const billingExplorerGranularGridViewInitialSelectedCsvColumns = new Set(
  ["resource_id", "resource_name"],
);
